import { AnyAction, PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ApiError } from '../../services/api';
import {
  fetchHubspotAccountDeals,
  IDeal
} from './hubspotDeals.thunks';
import { RootState } from '../rootReducer';
import { fetchAccountsList } from './list.thunks';
import { sendInvoiceForDeal } from './dealInvoices.thunk';

export interface IHubspotDeals {
  deals: IDeal[];
  loading: boolean;
  error: ApiError | null;
  selectedDeal?: IDeal;
}

const initialState: IHubspotDeals = {
  error: null,
  loading: false,
  deals: [],
  selectedDeal: undefined
};

const getDealsState = (state: Pick<RootState, 'accounts'>): IHubspotDeals | undefined => {
  return state.accounts.hubspotDeals;
};
const getError = (state: Pick<RootState, 'accounts'>): ApiError | undefined | null => getDealsState(state)?.error;
const getDeals = (state: Pick<RootState, 'accounts'>): IDeal[] => getDealsState(state)?.deals || [];
const getLoading = (state:Pick<RootState, 'accounts'>): boolean => getDealsState(state)?.loading || false;
const getSelectedDeal = (state:Pick<RootState, 'accounts'>):IDeal | undefined => getDealsState(state)?.selectedDeal;

export const hubspotDealsSelector = {
  getError,
  getDeals,
  getLoading,
  getSelectedDeal
};

const reducers = {
  [fetchHubspotAccountDeals.pending.type]: (state: IHubspotDeals): IHubspotDeals => {
    state.loading = true;
    state.error = null;
    return state;
  },
  [fetchHubspotAccountDeals.fulfilled.type]: (state: IHubspotDeals, action: AnyAction): IHubspotDeals => {
    state.loading = false;
    state.deals = action.payload?.deals ?? [];
    return state;
  },
  [fetchHubspotAccountDeals.rejected.type]: (state: IHubspotDeals, action: AnyAction): IHubspotDeals => {
    state.loading = false;
    state.error = action.payload;
    return state;
  },
  [fetchAccountsList.pending.type]: (state: IHubspotDeals): IHubspotDeals => {
    state.loading = false;
    state.error = null;
    state.deals = [];
    state.selectedDeal = undefined;
    return state;
  },
  [sendInvoiceForDeal.pending.type]: (state: IHubspotDeals): IHubspotDeals => {
    state.loading = true;
    return state;
  },
  [sendInvoiceForDeal.fulfilled.type]: (state: IHubspotDeals): IHubspotDeals => {
    state.loading = false;
    state.error = null;
    state.deals = [];
    state.selectedDeal = undefined;
    return state;
  },
  [sendInvoiceForDeal.rejected.type]: (state: IHubspotDeals): IHubspotDeals => {
    state.loading = false;
    return state;
  }
};

const hubspotDealsSlice = createSlice({
  name: 'hubspotDeals',
  initialState,
  extraReducers: reducers,
  reducers: {
    setSelectedDeal: (state: IHubspotDeals, action: PayloadAction<IDeal | undefined>) => {
      state.selectedDeal = action.payload;
      return state;
    },
    clearSelectedDeal: (state: IHubspotDeals) => {
      state.selectedDeal = undefined;
      return state;
    }
  }
});

export default hubspotDealsSlice.reducer;
export const actions = {
  ...hubspotDealsSlice.actions
};
